import * as Yup from 'yup'

export interface ICreateLicense {
  uuid?: string
  parent_id?: number[] | []

  enterprise_id?: [
    {
      id?: number
    }
  ]

  parentsLicense?: [
    {
      id?: number
    }
  ]

  license_type_id: number
  project_id: number
  issue_organ_id: number
  entrepreneur_id: number
  responsible?: string
  responsibles: number[] | []
  responsiblesT?: [
    {
      id?: number
    }
  ]

  field_id?: [
    {
      id?: number
    }
  ]
  license_number: string
  description: string
  issue_date: string
  expiration_date: string
  limit_renovation: string

  status: string
  control_conditionings?: boolean
  renovation_request_date?: string
  finalization_date?: string
  // file?: string | null
  file: File | null

  licenseAlertDay?: [
    {
      id?: number
      renovation_alert_day?: number
    }
  ]
  renovation_protocol?: string
  issue_cost?: string
  maintenance_cost?: string
  renovation_cost?: string

  renewable?: boolean
  expire?: boolean

  responsible_id: number[] | []
  renovation_alert_days: number[] | []
}

const createLicenseSchemas = [
  Yup.object({
    
  }),
  Yup.object({
    project_id: Yup.number().required('Campo Obrigatório'),    
    responsiblesT: Yup.array().min(1, 'Campo Obrigatório'),    
    license_number: Yup.string().required('Campo Obrigatório'),
    description: Yup.string().required('Campo Obrigatório'),
    issue_organ_id: Yup.string().required('Campo Obrigatório'),   
    license_type_id: Yup.number().required('Campo Obrigatório'),

    //PROBLEMA NA VALIDAÇÃO
    //field_id: Yup.number().required('Campo Obrigatório'),
    // entrepreneur_id: Yup.number().required('Campo Obrigatório'),
    //enterprise_id: Yup.number().required('Campo Obrigatório'),

  }),
  Yup.object({
    //issue_date: Yup.date().required('Campo Obrigatório'),
    //expiration_date: Yup.string().required('Campo Obrigatório'),
    status: Yup.string().required('Campo Obrigatório'),
  }),
  // Yup.object({
  //   nameOnCard: Yup.string().required().label('Name On Card'),
  //   cardNumber: Yup.string().required().label('Card Number'),
  //   cardExpiryMonth: Yup.string().required().label('Expiration Month'),
  //   cardExpiryYear: Yup.string().required().label('Expiration Year'),
  //   cardCvv: Yup.string().required().label('CVV'),
  // }),
]

const inits: ICreateLicense = {
  project_id: 0,
  entrepreneur_id: 0,
  license_number: '',
  description: '',
  issue_date: '',
  expiration_date: '',
  limit_renovation: '',
  status: '',
  renovation_alert_days: [],
  responsible_id: [],
  file: null,
  license_type_id: 0,
  issue_organ_id: 0,
  responsibles: [],
}

export {createLicenseSchemas, inits}
